class PasswordToggle extends HTMLElement {
  constructor() {
    super();
    this.isVisible = false;
  }
  connectedCallback() {
    this.input = this.parentElement.querySelector('input[type="password"], input[data-type="password"]');
    if (!this.input) return;
    this.iconShow = this.querySelector(".icon-eye");
    this.iconHide = this.querySelector(".icon-eye-off");
    this.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggle();
    });
  }
  toggle() {
    this.isVisible = !this.isVisible;
    this.input.type = this.isVisible ? "text" : "password";
    if (this.iconShow && this.iconHide) {
      this.iconShow.style.display = this.isVisible ? "block" : "none";
      this.iconHide.style.display = this.isVisible ? "none" : "block";
    }
  }
}
if (!customElements.get("password-toggle")) {
  customElements.define("password-toggle", PasswordToggle);
}
